(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('#stickyfaqnote')) {
            return
        }

        if (document.querySelector('body').classList.contains('faqbubble') || window.localStorage.getItem('closedbubble') !== 'false') {
            document.querySelector('#stickyfaqnote').classList.add('d-block')
            window.localStorage.setItem('closedbubble', 'false')
        }

        if (document.querySelector('#stickyfaqnote .close')) {
            document.querySelector('#stickyfaqnote .close').addEventListener(
              'click',
              () => {
                  document.querySelector('.message-box-forms.sticky-faqnote').remove()
              }
            )
        }
    })
}) ()

